<template>
  <div class="market_table">
    <div>
      <div>
        <span
          class="create_btn3"
          v-zoom="{ from: pageName, name: '创建任务' }"
          @click="newBtn()"
        >
          <img
            src="@/assets/images/member/new_establish.png"
            style="
              display: inline-block;
              float: left;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 9px -6px 0px 12px;
            "
          />
          创建任务
        </span>
        <div class="right_allBtn">
          开启状态:
          <el-select
            v-model="taskSearch.openFlag"
            placeholder="请选择"
            style="width: 116px; margin-left: 6px"
          >
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            v-model="taskSearch.searchKeyWord"
            placeholder="请输入任务名称、短信内容"
            style="width: 280px; margin: 0 16px 0 8px"
          ></el-input>
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getOrdersCareList1"
            class="status_btn status_btn1"
            :disabled="tableLoading"
            >查询</el-button
          >
          <el-button class="status_btn status_btn2" @click="resetBtn"
            >重置</el-button
          >
        </div>
      </div>
      <!-- 表格 -->
      <div class="clear-float">
        <el-table
          :data="tableList"
          style="width: 100%; margin-top: 22px"
          :header-cell-style="{ background: '#fafafa' }"
          v-loading="tableLoading"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="taskName" label="任务名称" min-width="180">
            <template slot-scope="scope">
              <div class="hoveTitle" v-if="!allShow">
                {{ scope.row.taskName }}
              </div>
              <div v-if="allShow">{{ scope.row.taskName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="短信内容" min-width="220">
            <template slot="header">
              <div
                style="
                  height: 40px;
                  line-height: 40px;
                  overflow: hidden;
                  float: left;
                "
              >
                短信内容
              </div>
              <div
                class="table-message"
                v-if="!allShow"
                :style="{ color: globalBG }"
                style="margin-left: 56px; line-height: 40px"
                @click="allShowBtn(1)"
              >
                展开全部
              </div>
              <div
                class="table-message"
                v-if="allShow"
                :style="{ color: globalBG }"
                style="margin-left: 56px; line-height: 40px"
                @click="allShowBtn(2)"
              >
                单行显示
              </div>
            </template>
            <template slot-scope="scope">
              <div class="hoveTitle" v-if="!allShow">
                {{ scope.row.content | enVToChinese }}
              </div>
              <div v-if="allShow">{{ scope.row.content | enVToChinese }}</div>
            </template>
          </el-table-column>
          <el-table-column label="任务时间" width="100">
            <template slot-scope="scope">
              <span>{{
                scope.row.persistentOpenFlag | persistentOpenFlagStr
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="最后修改时间"
            width="160"
          ></el-table-column>
          <el-table-column prop="taskRunStateDesc" label="优先级" width="185">
            <template slot="header">
              <div>
                优先级
                <el-tooltip
                  class="item"
                  effect="light"
                  content="数字越小优先级越高会优先发送，同一订单同时满足多个任务只发优先级高的，其他不发，避免重复，优先级相同则以最后修改时间先发。"
                  placement="top-start"
                >
                  <span class="question_icon">?</span>
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.sort"
                @change="handleChange(scope.row)"
                :min="1"
                :max="1000000000"
                size="small"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="开启状态" width="100">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.openFlag"
                v-zoom="{ from: pageName, name: '状态变化' }"
                @change="changeSwitch(scope.row)"
                active-color="#49C568"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="editOrderCare(scope.row)"
                type="text"
                class="edit_btn"
                v-zoom="{ from: pageName, name: '编辑' }"
                style="width: auto"
                >编辑</el-button
              >
              <el-button
                @click="deleteOrderCare(scope.row)"
                type="text"
                class="edit_btn_delete"
                v-zoom="{ from: pageName, name: '删除' }"
                style="width: auto"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="padding: 20px 28px 30px; text-align: right; margin-bottom: 0px"
      >
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 50, 100, 500, 1000]"
          :total="taskTableTotalCount"
          :page-size="taskSearch.size"
          :current-page="taskSearch.current"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <!-- <pagination @transferName="smsPaginationFunction" :total="taskTableTotalCount"></pagination> -->
    </div>
    <!-- 新建任务 pageConditionCom  -->
    <page-condition
      v-if="pageConditionCom"
      :postForms="detailFormData"
      :isAdd="isAdd"
      :menuType="menuIndex"
      :scorllY="topPX"
      :isShowTip="true"
      :bodyHeight="bodyHeight"
      @transferName="conditionBtnNone()"
      :drawer="true"
      :taskTypeActive="taskTypeActive"
    ></page-condition>
  </div>
</template>

<script>
import pageCondition from "../page-condition.vue";
import Pagination from "@/components/pagination.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  page,
  updateStatus,
  setRemindSort,
  addOrdersCare,
  orderCareInfo,
  delOrdersCare,
} from "@/api/care/orderCare";
export default {
  props: ["pageName"],
  components: {
    Pagination,
    pageCondition,
  },
  filters: {
    persistentOpenFlagStr(persistentOpenFlag) {
      return { false: "指定时间", true: "持续开启" }[persistentOpenFlag];
    },
  },
  data() {
    return {
      pageConditionCom: false, //编辑新建任务组件
      detailFormData: null,
      allShow: false, // 信息是否全部显示
      tableLoading: false,
      isAdd: true,
      topPX: "60px",
      $debounce: null, //防抖
      id: "",
      sort: "",
      taskSearch: {
        openFlag: "",
        searchKeyWord: "",
        size: 10,
        current: 1,
      },
      taskTableTotalCount: 0,
      tableList: [
        {
          taskName: "任务名称110",
          batchCount: "短信内容666",
          createdTime: "2020-06-16 15:46:50",
          taskType: 1,
          precedenceLevel: 2,
          isOpen: "1",
        },
      ],
      stateList: [
        {
          value: "",
          label: "-全部-",
        },
        {
          value: "1",
          label: "已开启",
        },
        {
          value: "0",
          label: "已关闭",
        },
      ],
    };
  },

  computed: {
    taskTypeActive() {
      return this.$route.meta.taskType;
    },
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    tittle() {
      return this.$route.name;
    },
    menuIndex() {
      return this.$route.meta.itemIndex;
    },
  },
  watch: {
    $route(to, from) {
      // console.log("watch==",to.path);
      this.getOrdersCareList();
    },
  },
  created() {
    console.log(this.pageName);
    this.getOrdersCareList();
    console.log(this.taskTypeActive);
    this.$debounce = this.debounce(() => {
      setRemindSort({
        configId: this.id,
        sort: this.sort,
      }).then((res) => {
        res.code === 1
          ? this.$message.success("操作成功")
          : this.$message.error(res.message);
      });
    }, 500);
  },
  methods: {
    //主页分页事件
    handleSizeChange(val) {
      this.taskSearch.size = val;
      this.taskSearch.current = 1;
      this.getOrdersCareList();
    },
    handleCurrentChange(val) {
      //console.log(val);
      this.taskSearch.current = val;
      this.getOrdersCareList();
    },
    // // 分页事件
    // smsPaginationFunction(event){
    //     this.taskSearch.current = event.current;
    //     this.taskSearch.size = event.pageSize;
    //     this.getOrdersCareList()
    // },
    /***
     * 任务列表-查询
     * */
    getOrdersCareList1(){
      this.taskSearch.current = 1;
      this.getOrdersCareList()
    },
    getOrdersCareList() {
      this.tableLoading = true;
      page({
        ...this.taskSearch,
        taskType: this.taskTypeActive,
      }).then((res) => {
        this.tableLoading = false;
        this.tableList = res.data.records;
        this.taskTableTotalCount = res.data.total;
      });
    },
    changeSwitch(val) {
      updateStatus({
        configId: val.id,
        state: val.openFlag,
      }).then((res) => {
        res.code === 1
          ? this.$message.success("操作成功")
          : this.$message.error(res.message);
      });
    },
    handleChange(val) {
      this.id = val.id;
      this.sort = val.sort;
      this.$debounce();
    },
    deleteOrderCare(row) {
      if (row.openFlag) {
        this.$message.warning("开启状态的任务不可删除！");
        return;
      }
      this.$confirm("是否确认删除任务？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        delOrdersCare(row.id).then((res) => {
          console.log(res);
          res.code === 1
            ? (this.$message.success("操作成功"), this.getOrdersCareList())
            : this.$message.error(res.message);
        });
      });
    },
    /*
     * 短信是否是全部显示
     * */
    allShowBtn(type) {
      if (type == 1) {
        this.allShow = true;
      } else {
        this.allShow = false;
      }
    },
    resetBtn() {
      this.taskSearch.openFlag = "";
      this.taskSearch.searchKeyWord = "";
      this.taskSearch.size = 10;
      this.taskSearch.current = 1;
      this.getOrdersCareList();
    },
    newBtn() {
      console.log("新建任务==");
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (this.topPX == "60px") {
        this.bodyHeight = height - 60;
      } else {
        this.bodyHeight = height - 60;
      }
      this.pageConditionCom = true;

      // 设置回显数据为空
      this.detailFormData = null;
    },
    editOrderCare(item) {
      orderCareInfo(item.id).then((res) => {
        console.log(res);
        // return
        //列表字符串转对象 回显
        let data = res.data;
        this.detailFormData = {
          taskName: data.taskName,
          taskType: data.persistentOpenFlag ? 0 : 1,
          taskStartTime: data.taskAllowRunStartTime,
          taskEndTime: data.taskAllowRunEndTime,
          sendOpportunity: data.sendOpportunity,
          sendUnitTime3: data.sendTimeType + "",
          startRemindTime: data.remindSendStart,
          endRemindTime: data.remindSendEnd,
          remindSendType: data.remindSendType == 0 ? "1" : "2",
          isLunchBreak: data.filterSendType,
          startLunchBreak: data.startFilterSendConfig,
          endLunchBreak: data.endFilterSendConfig,
          isOrderMoney: data.orderMoneyFilterType,
          startOrderMoney: data.orderMoneyStart,
          endOrderMoney: data.orderMoneyEnd,
          filterCondition: [],
          // areaType: data.appointAreaType == 0 ? "0" : "3",
          areaType: data.areaType + "",
          isAllItem: data.isAllItem + "",
          itemList: data.wareList,
          RemindLevel: data.gradeData.split(","),
          dealCount: data.buyTotalCountType == 1 ? true : false,
          startBuyTotalCount: data.startBuyTotalCount,
          endBuyTotalCount: data.endBuyTotalCount,
          isBuyerMessage: data.buyerRemarkFilterType == 1 ? true : false,
          buyerMessage: data.buyerRemarkConfig,
          isBuyerMessageSend: data.buyerRemarkIsSend ? "1" : "0",
          isProductNum: data.wareNumberConfigType == 1 ? true : false,
          startProductNum: data.startWareNumberConfig,
          endProductNum: data.endWareNumberConfig,
          isSellerRemark: data.venderRemarkFilterType == 1 ? true : false,
          sellerRemark: data.venderRemarkConfig,
          isSellerRemarkSend: data.sellerRemarkIsSend ? "1" : "0",
          payType: data.payTypeFilterData
            ? data.payTypeFilterData.split(",")
            : [],
          zip: data.provinceCodes ? data.provinceCodes : [],
          sendDays: data.sendDays,
          sendTime: data.sendTime,
          shipmentNum: data.waybillType + "",
          id: data.id,
          content: data.contnet,

          // 商品复购模块参数
          warePeriodType: data.warePeriodType,
          wareConsumeType: data.wareConsumeType + "",
          sendConditionDay: data.wareConsumeDay,
          sendConditionHour: data.sendTime,
          templateId: data.templateId,
          // filterBlacklistType:
        };

        //商品复购 - SKU商品选择
        if (data.warePeriodList && data.warePeriodList.length) {
          this.detailFormData.itemList = data.warePeriodList;
        }
        // 黑名单
        if (data.filterBlacklistType) {
          this.detailFormData.filterCondition.push("1");
        }
        // 周期内有购买原商品客户
        if (data.isFilterPeriodBuyer) {
          this.detailFormData.filterCondition.push("2");
        }
        if (this.menuIndex == 8) {
          this.detailFormData.isOrderMoney =
            data.buyTotalMoneyType == 1 ? true : false;
          this.detailFormData.startOrderMoney = data.startBuyTotalMoney;
          this.detailFormData.endOrderMoney = data.endBuyTotalMoney;
        }
        const height =
          document.documentElement.clientHeight || document.body.clientHeight;
        if (this.topPX == "60px") {
          this.bodyHeight = height - 60;
        } else {
          this.bodyHeight = height - 60;
        }
        this.pageConditionCom = true;
        this.isAdd = false;
      });
    },
    conditionBtnNone() {
      // this.getOrdersCare();
      // this.conditionState = 0;
      this.getOrdersCareList();
      setTimeout(() => {
        this.isAdd = true;
        this.pageConditionCom = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.market_table {
  .create_btn3 {
    width: 98px;
    height: 32px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    border-radius: 3px;
    display: inline-block;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    // margin-left: 28px;
    cursor: pointer;
    &:hover {
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
  .question_icon {
    width: 14px;
    height: 14px;
    color: #ccc;
    display: inline-block;
    line-height: 12px;
    text-align: center;
    border-radius: 14px;
    border: 1px solid #ccc;
    font-size: 12px;
    font-weight: normal;
  }
  .right_allBtn {
    float: right;
    margin-right: 28px;
    color: #333;
    font-size: 14px;
  }

  .status_btn {
    width: 98px;
    // height: 32px;
    border-radius: 3px;
    font-size: 14px;
  }
  .status_btn1 {
    color: #fe4d45;
    border-radius: 3px;
    margin-left: -8px;
    font-size: 14px;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .status_btn2 {
    margin-left: 8px;
    border-radius: 3px;
    font-size: 14px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .search_item {
    display: inline-block;
    margin-right: 79px;
    margin-bottom: 16px;
    color: #333;
  }
  .edit_btn {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .edit_btn_delete {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  .del_btn {
    font-size: 14px;
    padding: 0px !important;
    border: 0px;
    height: 20px;
    line-height: 20px;
    color: #fe4d45;
    margin-left: 0px;
  }
}
</style>